const DEFAULT_POLL_INTERVAL_MS = 5 * 60 * 1000;
/**
 * Framework-agnostic "new version available" poller: compares `currentVersion`
 * against whatever `fetchLatestVersion` returns, on an interval and whenever
 * `checkNow` is called directly (e.g. from a `visibilitychange` listener in
 * the consuming app). Browser wiring (fetch, visibility events, UI) is left
 * to the caller so this stays usable outside a DOM environment.
 */
export function createVersionPoller({ currentVersion, fetchLatestVersion, onNewVersionDetected, intervalMs = DEFAULT_POLL_INTERVAL_MS, }) {
    let timer;
    let notified = false;
    const checkNow = async () => {
        if (notified) {
            return;
        }
        try {
            const latestVersion = await fetchLatestVersion();
            if (latestVersion && latestVersion !== currentVersion) {
                notified = true;
                onNewVersionDetected(latestVersion);
            }
        }
        catch {
            // Best-effort: a failed check (offline, transient network error) just
            // waits for the next poll rather than surfacing an error to the user.
        }
    };
    const start = () => {
        if (timer) {
            return;
        }
        timer = setInterval(() => {
            void checkNow();
        }, intervalMs);
    };
    const stop = () => {
        if (timer) {
            clearInterval(timer);
            timer = undefined;
        }
    };
    return { start, stop, checkNow };
}
//# sourceMappingURL=createVersionPoller.js.map